import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { Bar, BarManagementService, BarQuery, BarQueryResponse } from 'src/app/api/api-bar-management.service.generated';


@Component({
  selector: 'app-outlet-search',
  templateUrl: './outlet-search.component.html',
  styleUrls: ['./outlet-search.component.scss'],
  imports: [
    MatFormFieldModule,
    MatTableModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    AsyncPipe
  ]
})
export class OutletSearchComponent implements OnInit {
  private bmApi = inject(BarManagementService);
  dialogRef = inject<MatDialogRef<OutletSearchComponent>>(MatDialogRef);
  data = inject<{
    outletId: string;
  }>(MAT_DIALOG_DATA);


  querySubject = new BehaviorSubject<string>('');
  isLoading = false;
  outlets$: Observable<Bar[]>;


  constructor() {

    this.outlets$ = this.querySubject.pipe(
      debounceTime(1000),
      switchMap(query => {
        this.isLoading = true;
        return this.bmApi.queryBars(new BarQuery({
          names: [query],
          skip: 0,
          maxItems: 100
        }));
      }
      ),
      map((resp: BarQueryResponse) => {
        this.isLoading = false;
        return resp.items || [];
      })
    );
  }

  static async open(dialog: MatDialog, outletId: string): Promise<Bar | undefined> {
    const result = await lastValueFrom(dialog.open(OutletSearchComponent, { width: '600px', height: '600px', data: { outletId } }).afterClosed());
    return result as (Bar | undefined);
  }

  ngOnInit() {
  }

  onChange(event: any) {
    this.querySubject.next(event.target.value);
  }

  selectOutlet(outlet: Bar) {
    this.dialogRef.close(outlet);
  }
}
